// API Configuration
// In development: Vite proxy redirects /api to http://localhost:3001
// In production: /api goes to the same domain (aulavirtual.adat-marc.com)
export const API_BASE_URL = import.meta.env.VITE_API_URL || '';
export const BASE_URL = API_BASE_URL.replace('/api', '');

// Helper function to build API URLs
export const apiUrl = (path) => {
    // Remove leading slash if present to avoid double slashes
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${API_BASE_URL}${cleanPath}`;
};
